import { render } from "./Work1Header.vue?vue&type=template&id=6238dcd4&scoped=true"
import script from "./Work1Header.vue?vue&type=script&lang=js"
export * from "./Work1Header.vue?vue&type=script&lang=js"

import "./Work1Header.vue?vue&type=style&index=0&id=6238dcd4&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6238dcd4"]])

export default __exports__